import { useEffect } from 'react';
import bannerImage from '../../assets/images/artist_application_banner.png';

export const SITE_URL = 'https://www.440artists.com';

const formOgImage = [
    ['meta[property="og:image"]', `${SITE_URL}${bannerImage}`],
    ['meta[property="og:image:secure_url"]', `${SITE_URL}${bannerImage}`],
    ['meta[property="og:image:width"]', '1728'],
    ['meta[property="og:image:height"]', '948'],
];

const valueKey = (selector) => (selector.startsWith('link') ? 'href' : 'content');

// Creates the tag when index.html lacks it; a null value removes it.
const setTag = (selector, value) => {
    let tag = document.head.querySelector(selector);
    if (value == null) return tag?.remove();
    if (!tag) {
        const [, element, attr, name] = selector.match(/^(\w+)\[(\w+)="([^"]+)"\]$/);
        tag = document.createElement(element);
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
    }
    tag.setAttribute(valueKey(selector), value);
};

export default function usePageMeta(page, { formOg = false } = {}) {
    useEffect(() => {
        const selectors = ['meta[name="description"]', 'meta[name="robots"]', 'link[rel="canonical"]', ...formOgImage.map(([selector]) => selector)];
        const readValue = (selector) => document.head.querySelector(selector)?.getAttribute(valueKey(selector)) ?? null;
        const previousTitle = document.title;
        const previousValues = selectors.map((selector) => [selector, readValue(selector)]);

        document.title = page.metaTitle;
        setTag('meta[name="description"]', page.description);
        setTag('meta[name="robots"]', page.noindex ? 'noindex, nofollow' : 'index, follow');
        setTag('link[rel="canonical"]', `${SITE_URL}${page.path}`);
        if (formOg) formOgImage.forEach(([selector, value]) => setTag(selector, value));

        return () => {
            document.title = previousTitle;
            previousValues.forEach(([selector, value]) => setTag(selector, value));
        };
    }, [page, formOg]);
}
